<template>
  <Popover ref="popover">
    <template #trigger="{ onClick, props }">
      <AppTooltip :disabled="disabled || !tooltipText">
        <template #activator="{ props: tooltipProps }">
          <div v-bind="{ ...props, ...tooltipProps }" @click="(e) => handleClick(e, onClick)">
            <slot name="trigger" />
          </div>
        </template>
        <span>{{ tooltipText }}</span>
      </AppTooltip>
    </template>

    <slot />
  </Popover>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'

import Popover from './Popover.vue'

export default {
  name: 'FeedbackPopover',
  components: { AppTooltip, Popover },
  props: {
    autoCloseDelay: {
      type: Number,
      default: 3000,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClick(event, originalClick) {
      this.$refs.popover?.open()

      if (typeof originalClick === 'function') {
        originalClick(event)
      }

      setTimeout(() => {
        this.$refs.popover?.close()
      }, this.autoCloseDelay)
    },
  },
}
</script>
